/**
 * Глобальний обробник для автоматичного додавання вібрації до всіх кнопок
 * Ініціалізується один раз при завантаженні додатку
 */

import { impactOccurred } from './hapticFeedback';

/**
 * Ініціалізує глобальний обробник кліків на кнопки
 * Автоматично додає вібрацію до всіх кнопок в додатку
 */
export function initGlobalButtonHaptic(): void {
  // Додаємо обробник на рівні document для всіх кліків
  document.addEventListener('click', (event) => {
    const target = event.target as HTMLElement;
    
    // Перевіряємо чи це кнопка або елемент всередині кнопки
    const button = target.closest('button, [role="button"], [data-button="true"]');
    
    if (button) {
      // Перевіряємо чи кнопка не вимкнена
      const isDisabled = button.hasAttribute('disabled') || 
                        button.getAttribute('aria-disabled') === 'true' ||
                        (button as HTMLButtonElement).disabled;
      
      if (!isDisabled) {
        // Додаємо легку вібрацію для всіх кнопок
        impactOccurred('light');
      }
    }
  }, true); // Використовуємо capture phase для раннього перехоплення
}

